import { initPixi, app, gearContainer, backgroundContainer, resetBackground, mainContainer, resetMenuGraphics, menuGraphics} from './app'
import { createDefault, menuHeading, menuIndicator, menuSubheading } from './screens/default'
import { Container } from 'pixi.js'
import { findSettingByID, pageInfo, saveSettings, Setting, settings, settingValue } from './settings'
import { currentPalette, setPalette} from './palettes'
import { interpColour } from './utils/customMaths'

let currentScreen: Container | null = null

const defaultMessage = document.getElementById('message');
const AppRoot = document.getElementById('root');


async function showScreen(screenFactory: () => Promise<Container>) {
  // Remove current screen
  if (currentScreen) {
    app.stage.removeChild(currentScreen)
    currentScreen.destroy({ children: true })
    currentScreen = null
  }
  
  // Create and add new screen
  currentScreen = await screenFactory()
  
  app.stage.addChild(currentScreen)
  
  console.log("gear container",  gearContainer.width)
    console.log("backgroundContainer container",  backgroundContainer.width)
    console.log("mainContainer container",  mainContainer.width)

  

  //disable message if successful
  if (currentScreen) {
    await makeSettings()
    
    defaultMessage?.style.setProperty("opacity", "0.0");
    defaultMessage?.style.setProperty("pointer-events", "none");
  }
}

const cover = document.getElementById("cover");
let coverOpacity = 2.0;


const removeCover = () => {
  if (coverOpacity >= 0.0) {
      coverOpacity -= 0.025;
      cover?.style.setProperty('opacity', ` ${coverOpacity}`);
      requestAnimationFrame(removeCover)
  } else {
    coverOpacity = 0.0;
    cover?.style.setProperty('opacity', `0`);
    cover?.style.setProperty("pointer-events", "none");
  }
}

async function main() {

  const time  = new Date();
  console.log("Start-up time: "+time)

  // setPalette(0);

  const pixi = await initPixi();
  
  pixi.canvas.style.touchAction = 'none';
  // app.ticker.maxFPS = 100;
  app.ticker.minFPS = 30;
  app.ticker.maxFPS = settingValue(findSettingByID(31)) ?? 45; //set limit to refresh rate, lower GPU usage

  AppRoot?.appendChild(pixi.canvas);
  showScreen(createDefault)
  
  
  
  
  requestAnimationFrame(removeCover)

  //prevent double taps to prevent zoom-in
  let lastTap = 0;

  const options = document.querySelector('.options');
  const menu = document.querySelector('.menu');

  menu?.classList.toggle("html-effects", (settingValue(findSettingByID(30)) ?? 1) === 1);

  options?.addEventListener('touchend', (e) => {
    const now = Date.now();
    if (now - lastTap < 300) {
      e.preventDefault();
    }
    lastTap = now;
  }, { passive: false });

  
  // //enable horizontal scroll in landscape on desktop - touch events will allow as normal for mobile
  // options?.addEventListener('wheel', (e) => {
  //   if (!options.classList.contains('portrait')) {
  //     const wheelEvent = e as WheelEvent;
  //     e.preventDefault();
  //     options.scrollLeft += wheelEvent.deltaY;
  //   }
  // }, {passive: false})

  options?.addEventListener('wheel', (e) => {
    console.log("Register wheel event")
    if (!options.classList.contains('portrait')) {
      console.log("Landscape")
      const pages = options?.children;
      let countedPages = 0;
      if (pages)
      for (let i = 0; i < pages.length; i++) {
        
        // if (countedPages++ !== pageOpen) return;
        const page = pages.item(i);
        if (page?.classList.contains("page")) {
          const wheelEvent = e as WheelEvent;
          e.preventDefault();
          page.scrollLeft += wheelEvent.deltaY;
        }
      }
      
    }
  }, {passive: false})

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
        app.ticker.stop(); 
    } else {
        app.ticker.start();
    }
  });
}

//page transitions
export const book: number[][] = [
  //help pages
  [1, 5],
  //network pages
  [2,6,7,8],
  //item pages
  [3,12,9,10,11],
  //setting pages
  [0,13,14],
]
const groupNames = ["Info","Global","Reserves","Settings"]
export let groupPagesSelected: number[] = [0,0,0,0];
export let pageGroupOpen: number| undefined = undefined;
export let pageOpen: number = 0;
//used to be pageOpen

export function transitionPageGroup(group: number) {
  if (pageGroupOpen === group) return false;
  pageGroupOpen = group;
  
  changePage();
  menuHeading.attachment.text = groupNames[group];
  menuHeading.updateText();
  
  console.log("Transitioned to group "+group+", page selected is "+pageOpen)
  
  return true;
}

function changePage() {
  if (pageGroupOpen === undefined) return false;
  let pageTally = 0;
  for (let i = 0; i <= pageGroupOpen; i++) {
    if (i === pageGroupOpen) {
      pageTally += groupPagesSelected[pageGroupOpen]
      break;
    }
    pageTally += book[i].length;
  }
  const pageObject = settings.find(page => page.pageID === book[pageGroupOpen!][groupPagesSelected[pageGroupOpen!]])
  if (pageObject !== undefined) {
    menuSubheading.attachment.text = pageObject.title;
    menuSubheading.updateText();
  }
  
  pageOpen = pageTally;
  let indicatorString = "";
  for (let i = 0; i < book[pageGroupOpen].length ; i++) {
    if (i === groupPagesSelected[pageGroupOpen]) {
      indicatorString += "●"
    } else {
      indicatorString += "○"
    }
    if (i !== book[pageGroupOpen].length) indicatorString += " ";
  }
  menuIndicator.attachment.text = indicatorString;
  menuIndicator.updateText();
  setHeadingWidths();
}

export function transitionPage(isForward: boolean) {

  console.log("You pressed the > button!")
  
  if (pageGroupOpen === undefined) return;
  console.log("Working now...")
  if (isForward) {
    groupPagesSelected[pageGroupOpen] = groupPagesSelected[pageGroupOpen] === book[pageGroupOpen].length - 1 ? 0 : groupPagesSelected[pageGroupOpen]+1;
  } else {
    groupPagesSelected[pageGroupOpen] = groupPagesSelected[pageGroupOpen] === 0? book[pageGroupOpen].length - 1 : groupPagesSelected[pageGroupOpen]-1;
  }
  console.log("Did I work? :D")
  changePage();
}


//colour shift
const toHex = (num: number) => "#" + num.toString(16).padStart(6,"0");

const cssValue = getComputedStyle(document.documentElement).getPropertyValue('--backgroundColour');
const initialColour = parseInt(cssValue.replace('#', ''), 16);

let lastBack1 = -1, lastText1 = -1, lastText2 = -1, lastBack2 = -1;
let colourTickLast = 0;

const colourTick = () => {
  if (colourTickLast++ < 4 && coverOpacity === 0) return;
  colourTickLast = 0;
    if (currentPalette.text2 !== lastText2) {
        document.documentElement.style.setProperty('--lightColour', toHex(currentPalette.text2));
        lastText2 = currentPalette.text2;
    }
    if (currentPalette.text1 !== lastText1) {
        document.documentElement.style.setProperty('--midColour', toHex(currentPalette.text1));
        lastText1 = currentPalette.text1;
    }
    if (currentPalette.back2 !== lastBack2) {
        document.documentElement.style.setProperty('--darkColour', toHex(currentPalette.back2));
        lastBack2 = currentPalette.back2;
    }
    if (coverOpacity >= 0.0) {
        const transitionColour = interpColour(currentPalette.back1, initialColour, Math.max(coverOpacity - 1.0, 0));
        if (transitionColour !== lastBack1) {
            document.documentElement.style.setProperty('--backgroundColour', toHex(transitionColour));
            lastBack1 = transitionColour;
        }
    } else {
        if (currentPalette.back1 !== lastBack1) {
            document.documentElement.style.setProperty('--backgroundColour', toHex(currentPalette.back1));
            lastBack1 = currentPalette.back1;
        }
        app.ticker.remove(colourTick);
    }
};

export function updateHTMLColour(isOn: boolean){
  
  // const finalColour = currentPalette.back1;
  const cssValue = getComputedStyle(document.documentElement).getPropertyValue('--backgroundColour');
  const initialColour = parseInt(cssValue.replace('#', ''), 16);

  if(isOn){
  app.ticker.add(colourTick)
  }
  

}

/**
 * Set heading widths for settings menu based on screen size
 */
export function setHeadingWidths(){
  const options = document.querySelector(".options") as HTMLElement;
  for (let i = 0; i < options.children.length; i++) {

    if (options.children.item(i)?.classList.contains("page")) {
      const page = options.children.item(i) as HTMLElement;
      if (!page) continue;

      const scrollLeft = page.scrollLeft;
      const scrollTop = page.scrollTop
      const oldWidth = page.scrollWidth;
      const oldHeight = page.scrollHeight;
      //page.scrollLeft can be reduced here

      if (pageOpen < i) {
        page.style.setProperty('transform', `translateX(400vw)`)
      } else if (pageOpen > i) {
        page.style.setProperty('transform', `translateX(-400vw)`)
      } else {
        page.style.setProperty('transform', `translateX(0px)`)
      }

      for (let j = 0; j< page.children.length; j++) {
        if (page.children.item(j)?.classList.contains("heading-group")) {
          const group = page?.children.item(j) as HTMLElement;
          if (!group) continue;
          // console.log(group)

          group.style.position = "absolute"
          group.style.minWidth = "auto";
          group.style.minHeight = "auto";
          
          let width = group.scrollWidth;
          let height = group.scrollHeight;

          group.style.position = ""
          group.style.minWidth = `${width}px`;
          group.style.minHeight = `${height}px`;
        }
      }

      
      page.scrollLeft = page.scrollWidth*scrollLeft/oldWidth;
      page.scrollTop = page.scrollHeight*scrollTop/oldHeight;

    }

  }
}

const settingMap = new Map<number, HTMLElement>();

/**
 * Create html representations of all settings
 */
async function makeSettings(){
  
  const root = document.querySelector(".options") as HTMLElement;
  root.innerHTML = "";
  
  //PAGES
  for (let pageGroup = 0; pageGroup < book.length; pageGroup++) {
    for (let pageRef = 0; pageRef < book[pageGroup].length; pageRef++) {
      const page = settings.find(page => page.pageID === book[pageGroup][pageRef]);
      if (page === undefined) continue;

      // const pageID = page.pageID;
      const pageDiv = document.createElement("div");
      pageDiv.classList.add("page");
          
      //one-off profile div
      const profileHG = document.createElement("div");
      profileHG.classList.add("heading-group")
      const profileHeading = document.createElement("h2");
      profileHeading.textContent = "Profiles";
      profileHG.appendChild(profileHeading)
      const profileSG = document.createElement("div");
      profileSG.classList.add("setting-group");

      const profileDiv = document.createElement("div");
      profileDiv.classList.add("setting")
      //dont need to add to settingMap - no update functionality needed as no dependencies
      const profileText = document.createElement("p");
      // const profile = page.profiles.find(p => p.profileID === page.selectedProfile);
      profileText.textContent = page.title+" Profile:";
      profileDiv.appendChild(profileText);

      const profileBack = document.createElement("div");
          profileBack.classList.add("setting-back")
          profileDiv.appendChild(profileBack);
        const profileDepth = document.createElement("div");
        profileDepth.classList.add("setting-depth");
        profileBack.appendChild(profileDepth)

      console.log("Selected Profile: "+page.selectedProfile)

      const profiles = document.createElement("select")

      page.profiles.forEach(option => {
        console.log(option.profileID)
        if (option.profileID === 0) return; // skip default profile
        const optionElement = document.createElement("option")
        optionElement.textContent = option.title
        optionElement.value = String(option.profileID ?? 1) //sets to 1 if profile is 0
        optionElement.selected = (page.selectedProfile === option.profileID)
        profiles.appendChild(optionElement)
      })

      profiles.onchange = () => {
        
        page.selectedProfile = Number(profiles.value)
        saveSettings();
        updateDependencies();
        updateSettings();

      }
      profileDiv.appendChild(profiles)
      // new ViewportGraphics({destContainer: graphicsContainer, attachedHTML: profileDiv, menuFade: true, alphaMult: 1})
      pageDiv.appendChild(profileHG)
      profileHG.appendChild(profileSG)
      profileSG.appendChild(profileDiv)

      //HEADINGS
      page.headings.forEach(heading => {
        const headingGroup = document.createElement("div");
        headingGroup.classList.add("heading-group")

        const headingElement = document.createElement("h2");
        headingElement.textContent = heading.title;
        headingGroup.appendChild(headingElement);

        const settingGroup = document.createElement("div");
        settingGroup.classList.add("setting-group")

          
        //SETTING GROUPS
        heading.settings.forEach(setting => {

          const val = settingValue(setting); //getting value for current profile
          
          const settingDiv = document.createElement("div");
          settingDiv.classList.add("setting")

          settingMap.set(setting.settingID, settingDiv);
          
          if (setting.sub !== undefined) {
            settingDiv.classList.toggle("indent", true);
          }

          const settingText = document.createElement("p");
          
          settingText.textContent = setting.title+((setting.type === 'toggle')?"? " : ": ");
          settingDiv.appendChild(settingText);

          let value: HTMLSelectElement | HTMLInputElement;

          //SELECT BOX
          if (setting.type === "select") {
            value = document.createElement("select")
            setting.options.forEach(option => {
              const optionElement = document.createElement("option")
              optionElement.textContent = option.title
              optionElement.value = String(option.id)
              optionElement.selected = (val === option.id)
              value.appendChild(optionElement)
            })

            //update select value
            value.onchange = () => {
              
              //restrict input to accepted values
              if (isLocked(setting) || !isEnabled(setting) || setting.options.some( option => option.id === Number(value))) {
                const prev = setting.value;
                value.value = String(prev)
                updateDependencies();
                return;
              }

              

              setting.value.set(page.selectedProfile, Number(value.value)) 
              
              saveSettings(setting);
              
              updateDependencies();
            }

            settingDiv.appendChild(value)

          //RANGE SELECT
          } else if (setting.type === "range") {
          
            const rangeContainer = document.createElement("div");
            value = document.createElement("input")
            value.type = "range";
            value.value= String(val);
            value.min = String(setting.lower);
            value.max = String(setting.upper);

            const indicator = document.createElement("p");
            indicator.textContent = value.value;

            //update range number
            value.onchange = () => {

              if (isLocked(setting) || !isEnabled(setting) || Number(value.value) < setting.lower || Number(value.value) > setting.upper ) {
                const prev = setting.value;
                value.value = String(prev)
                updateDependencies();
                return;
              }

              setting.value.set(page.selectedProfile, Number(value.value)) 
              indicator.textContent = value.value;
              saveSettings(setting);
              updateDependencies();
            }

            settingDiv.appendChild(rangeContainer)
            rangeContainer.appendChild(value)
            rangeContainer.appendChild(indicator)

          //CHECKBOX SELECT  
          } else if (setting.type === 'toggle') {
            const checkbox = document.createElement("input")
            checkbox.type = "checkbox"
            checkbox.checked = (settingValue(setting) === 1)

            //update boolean
            checkbox.onchange = () => {

              if (isLocked(setting) || !isEnabled(setting)) {
                const prev = setting.value;
                value.value = String(prev) //block manual changes in client code
                updateDependencies();
                return;
              }

              


              setting.value.set(page.selectedProfile, Number(checkbox.checked))
              if (setting.settingID === 36 || setting.settingID === 39) resetBackground(); //re-enable background when initiating live view mode
              saveSettings(setting);
              updateDependencies();
            }

            settingDiv.appendChild(checkbox)
          }
          
          const settingBack = document.createElement("div");
          settingBack.classList.add("setting-back")
          settingDiv.appendChild(settingBack);
          const settingDepth = document.createElement("div");
          settingDepth.classList.add("setting-depth");
          settingBack.appendChild(settingDepth)
          // new ViewportGraphics({destContainer: graphicsContainer, attachedHTML: settingDiv, menuFade: true, alphaMult: 1})

          settingGroup.appendChild(settingDiv);

          if (setting.subtitle) {
            const subtitle = document.createElement("p");
            subtitle.textContent = setting.subtitle;
            subtitle.classList.add("subtitle");
            settingGroup.appendChild(subtitle)
            // new ViewportGraphics({destContainer: gearContainer, attachedHTML: subtitle, menuFade: true, alphaMult: 0.67})
          }
          
          
        })

        headingGroup.appendChild(settingGroup);
        pageDiv.appendChild(headingGroup);

      })

    root.appendChild(pageDiv);
    resetMenuGraphics();
  
    }
  }

  // mouseTracking();

  setPalette() //set palette after menu items are created to ensure correct colouration
  updateDependencies();
}

function isEnabled(setting: Setting) {
  if (setting.requirements !== undefined) {
    if (setting.requirements.every((requirement) => {
      if (requirement === undefined) return true; //skip duds
      const required = findSettingByID(requirement.requiredID);
      if (!required) return false;
      const value = settingValue(required);
      if (value === undefined) return false;
      if (requirement.accepted.includes(value)) return true;
    })) return true;
  } else return true; //no requirements, is enabled
}

function isLocked(setting: Setting) {
  const page = pageInfo(setting)
  if (!page) return;
  const currentProfile = page.selectedProfile;
  const profile = page.profiles.find(p => p.profileID === currentProfile)
  if (currentProfile === undefined || profile === undefined) return false;
  return (setting.value.has(currentProfile) && setting.lockedProfiles?.includes(currentProfile))
}

function updateDependencies() {
  settings.forEach(page => {
    page.headings.forEach(heading => {
      heading.settings.forEach(setting => {
        
        const element = settingMap.get(setting.settingID);
        if (!element) return;

        const enabled = isEnabled(setting);
        element.classList.toggle("disabled", !enabled);

        //locking profile specific settings
        if (enabled && isLocked(setting)) {
          element.classList.toggle("locked", true);
        } else {
          element.classList.toggle("locked", false);
        }

      })
    })
  })
}

function updateSettings(){
  settings.forEach(page => {
    page.headings.forEach(heading => {
      heading.settings.forEach(setting => {
        const element = settingMap.get(setting.settingID);
        if (!element) return;
        
        const container = element.querySelector('div') as HTMLElement | null;
        const select = element.querySelector('select') as HTMLSelectElement | null;

        const input = container?.querySelector('input') as HTMLInputElement | null;
        
        const label = container?.querySelector('p') as HTMLElement | null;

        const checkbox =  element?.querySelector('input') as HTMLInputElement | null;

        const value = settingValue(setting)
      
        if (select) {
          select.value = String(value);
        } else {
          
        }

        if (input) {
            input.value = String(value)
        }

        if (checkbox) {
          checkbox.checked = (value ?? 0) === 1;
        }

        if (label) {
          label.textContent = String(value)
        }

      })
    })
  })
}

main()